module.exports = __webpack_public_path__ + "media/images/printer-0dbb0fdf.svg";